import React from 'react'
import './styles.scss'
import { CaretRight } from '@phosphor-icons/react'

interface AgreementButtonProps {
  text: string
  openModal: (app: 'guardian' | 'mentor' | 'organizer') => void
}

const AgreementButton: React.FC<AgreementButtonProps> = ({
  text,
  openModal,
}) => {
  const handleClick = (text: string) => {
    switch (text) {
      case 'For Family':
        openModal('guardian')
        break
      case 'For Mentors':
        openModal('mentor')
        break
      case 'For Organizers':
        openModal('organizer')
        break
      default:
        break
    }
  }

  return (
    <>
      <button
        className="agreement-initailizer pointer"
        onClick={() => handleClick(text)}
      >
        {text}
        <CaretRight size={20} color="#000" />{' '}
      </button>
    </>
  )
}

export default AgreementButton
